module.exports = __webpack_public_path__ + "media/images/proof_links/colored/ask-1854e4166022f2545162e4e6df842407.svg";